import ErrorToast from "../../components/common/toasts/ErrorToast";
import React from "react";
import { Link, Navigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AddOrderPage from "./pages/orders/AddOrderPage";
import OrderList from "./OrderList";
import PremiumLayout from "./components/PremiumLayout";
import PremiumTabs from "./components/PremiumTabs";
import CompanyList from "./components/CompanyList";
import Dictionaries from "./Dictionaries";
import PremiumNotice from "./components/PremiumNotice";

import usePremiumResource from "./hooks/usePremiumResource";
import { premiumPaths } from "./navigation";

export default function Premium({ section = "orders", action = "list" }) {
  const { accessToken, checkPermission } = useAuth();
  const { companyId } = useParams();
  const [params] = useSearchParams();
  const { data, error, loading, reload } = usePremiumResource(
    accessToken,
    companyId ? `/organizations/${companyId}` : null,
  );
  const organization = data?.organization;
  const admin = checkPermission("Zarządzanie użytkownikami");
  if (!companyId && params.get("company"))
    return <Navigate to={premiumPaths.orders(params.get("company"))} replace />;
  const title = {
    orders: "Świadectwa Premium",
    new: "Nowe świadectwo",
    dictionaries: "Słowniki firmy",
  }[section];
  return (
    <PremiumLayout
      title={companyId ? title : "Konto Premium"}
      subtitle={organization?.name}
      actions={
        organization ? (
          <>
            {admin && section !== "new" && (
              <Link
                className="btn btn-outline-primary"
                to={premiumPaths.settings(companyId)}
              >
                Zarządzaj firmą
              </Link>
            )}
            {section === "orders" && organization.active && (
              <Link
                className="btn btn-primary"
                to={premiumPaths.newOrder(companyId)}
              >
                Nowe świadectwo
              </Link>
            )}
          </>
        ) : (
          admin && (
            <Link className="btn btn-outline-primary" to={premiumPaths.admin}>
              Firmy Premium
            </Link>
          )
        )
      }
    >
      <ErrorToast message={error} />
      {loading && <p role="status">Ładowanie firmy…</p>}
      {error && (
        <div className="premium-button-group">
          <Link to={premiumPaths.home}>Wróć do konta Premium</Link>
          <button className="btn btn-outline-primary" onClick={reload}>
            Ponów odczyt
          </button>
        </div>
      )}
      {!companyId && <CompanyList token={accessToken} />}
      {organization && (
        <>
          {!organization.active && (
            <PremiumNotice warning>
              Firma jest nieaktywna. Nie można dodawać nowych świadectw.
            </PremiumNotice>
          )}
          {section !== "new" && (
            <PremiumTabs
              label="Sekcje konta Premium"
              items={[
                { label: "Świadectwa", to: premiumPaths.orders(companyId) },
                { label: "Słowniki", to: premiumPaths.dictionaries(companyId) },
              ]}
            />
          )}
          {section === "orders" && (
            <OrderList
              key={companyId}
              organization={organization}
              token={accessToken}
            />
          )}
          {section === "dictionaries" && (
            <Dictionaries
              key={companyId}
              organization={organization}
              token={accessToken}
              action={action}
            />
          )}
          {section === "new" && (
            <AddOrderPage
              key={companyId}
              organization={organization}
              token={accessToken}
            />
          )}
        </>
      )}
    </PremiumLayout>
  );
}
